module.exports = __webpack_public_path__ + "public/img/arrow-lb.bc4dc9b9.svg";